import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(public auth: AuthService) { }

  async canActivate(): Promise<boolean> {
    if (!await this.auth.checkToken()) {
      await this.auth.ssoFlow();
      return false;
    }
    return true;
  }
}
